import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from "redux-thunk";
import { createBrowserHistory } from 'history';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './root-reducer';

export const history = createBrowserHistory();

const composeEnhancers = composeWithDevTools({
  trace: true,
  traceLimit: 25
});


const store = createStore(rootReducer(history), composeEnhancers(applyMiddleware(routerMiddleware(history), thunk)));

export default store;
